var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BB0000"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E0A0A"
    },
    d: "M315.292,505.084c80.518-19.096,146.308-76.212,177.371-151.347L336.567,197.641l-3.368,4.511 l-87.161-87.161l-14.984,132.646L337.506,354.09l-10.481,12.435l-96.173-96.173l-79.246,40.56l54.346,54.346l-15.522,14.96 L315.292,505.084z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232.217,315.949l-40.52,49.342c-5.703,6.94-2.975,17.425,5.38,20.716l39.617,15.593 c8.547,3.363,17.836-2.786,18.079-11.966l1.708-64.638C256.826,311.967,240.488,305.874,232.217,315.949L232.217,315.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M225.483,266.895l-60.094-21.576c-8.456-3.036-17.415,3.055-17.701,12.035l-1.37,42.551 c-0.297,9.182,8.62,15.862,17.349,13.005l61.447-20.12C237.502,288.732,237.749,271.3,225.483,266.895L225.483,266.895z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M294.353,273.818l61.556-16.965c8.659-2.388,12.479-12.524,7.542-20.034l-23.385-35.575 c-5.046-7.673-16.181-8.004-21.669-0.64l-38.653,51.833C271.953,262.887,281.79,277.28,294.353,273.818L294.353,273.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.777,125.902c0.49-10.645-9.542-18.677-19.823-15.869l-48.723,13.307 c-10.511,2.87-14.974,15.31-8.688,24.209l55.913,96.87c0.453,0.79,0.955,1.55,1.543,2.239c8.282,9.733,23.824,6.127,27.658-5.265 c0.686-2.046,0.881-4.229,0.714-6.378L249.777,125.902z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M356.33,318.1l-61.812-18.978c-12.459-3.827-22.711,10.278-15.224,20.947l36.671,52.269 c5.161,7.354,15.991,7.542,21.402,0.372l25.643-33.983C368.542,331.393,365.109,320.793,356.33,318.1L356.33,318.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M257.657,241.392c0.686-2.046,0.881-4.229,0.714-6.378l-8.594-109.111 c0.49-10.645-9.542-18.677-19.823-15.869l-26.679,7.285l42.858,134.456C251.271,250.508,255.817,246.86,257.657,241.392z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYelp);
export default __webpack_public_path__ + "static/media/yelp.6dbf1cd028a03da05821e75f331a8a34.svg";
export { ForwardRef as ReactComponent };